const teamData = {
    "2026": {
        "Organizers": [
            
            {
                title: "Lucy Wu",
                description: "Undergraduate Student",
                imgPath: "assets/team/Lucy_Wu.webp",
                team: "Hackathon Chair",
                websiteLink:"https://www.linkedin.com/in/hsin-ju-lucy-wu-381338213/"
            },
            {
                title: "Roza G. Bayrak",
                description: "Senior Research Engineer",
                team: "General Chair",
                imgPath: "assets/team/Roza_Bayrak.webp",
                ghLink: "https://github.com/rgbayrak",
                websiteLink: "https://rgbayrak.github.io/"
            },
            {
                title: "Eunice Hahm",
                description: "Undergraduate Student",
                imgPath: "assets/team/Eunice_Hahm.webp",
                team: "Projects Team Lead",
                websiteLink:"https://www.linkedin.com/in/eunice-hahm-1bb555327"
            },
            {
                title: "Lily Kriegel",
                description: "Undergraduate Student",
                imgPath: "assets/team/Lily_Kriegel.webp",
                team: "Educationals Team Lead",
                ghLink:"https://github.com/lilysimone22-ctrl",
                websiteLink:"https://www.linkedin.com/in/lily-kriegel-548714398"
            },
            {
                title: "Ankith Cirgir",
                description: "Web Developer",
                imgPath: "assets/team/Ankith_Cirgir.webp",
                team: "Dev Team Lead",
                ghLink: "https://github.com/Ankith-Cirgir",
                websiteLink: "https://www.linkedin.com/in/ankith-cirgir/"
            },
            {
                title: "Crystal Jiang",
                description: "Undergraduate Student",
                imgPath: "assets/team/placeholder1.webp",
                team: "Marketing Team Lead/Dev Team"
            },
            {
                title: "Liza Akpoli",
                description: "Undergraduate Student",
                imgPath: "assets/team/Liza_Akpoli.webp",
                team: "Operations Team Lead",
                ghLink: "https://github.com/lizaakpoli",
                websiteLink:"https://www.linkedin.com/in/liza-a-8397b7320"
            },
            {
                title: "Sarah Goodale",
                description: "Postdoctoral Researcher",
                imgPath: "assets/team/Sarah_Goodale.webp",
                team: "Operations Co-Team Lead",
                ghLink: "https://github.com/goodalse2019",
                websiteLink: "https://www.linkedin.com/in/goodale-sarah/"
            },
            {
                title: "Gauri Agarwal",
                description: "Undergraduate Student",
                imgPath: "assets/team/placeholder1.webp",
                team: "Educationals Team",
            },
            {
                title: "Karen Escobar-Salgado",
                description: "Undergraduate Student",
                imgPath: "assets/team/Karen_Escobar-Salgado.webp",
                team: "Operations Team"
            },
            {
                title: "Gyuri Ramos",
                description: "Undergraduate Student",
                imgPath: "assets/team/Gyuri_Ramos.webp",
                team: "Operations Team"
            },
            {
                title: "Kristine Won",
                description: "Undergraduate Student",
                imgPath: "assets/team/Kristine_Won.webp",
                team: "Dev Team"
            },
            {
                title: "Catie Chang",
                description: "Associate Professor",
                team: "Faculty Advisor",
                imgPath: "assets/team/Catie_Chang.webp"
            },
            {
                title: "Nick Lord",
                description: "Executive Project Coordinator",
                team: "Admin",
                imgPath: "assets/team/Nick_Lord.webp"
            }
        ]
    },
    "Other": {
        "Organizers": [
            {
                title: "Gaurav Rudravaram",
                description: "Undergraduate Student",
                imgPath: "assets/team/Gaurav_Rudravaram.webp",
                team: "Volunteer",
                ghLink:"https://github.com/GauravR1206",
                websiteLink:"https://www.linkedin.com/in/gaurav-rudravaram-7ba95a179"
            },
            {
                title: "Nishanth Basava",
                description: "Undergraduate Student",
                imgPath: "assets/team/Nishanth_Basava.webp",
                team: "Volunteer",
                ghLink:"https://github.com/nishanthbasava",
                websiteLink:"https://www.linkedin.com/in/nishanth-basava/"
            },
            {
                title: "Sefika Ozturk",
                description: "Undergraduate Student",
                imgPath: "assets/team/Sefika_Ozturk.webp",
                team: "Volunteer"
            },
            {
                title: "Juan Gomez Lagandara",
                description: "PhD Student",
                imgPath: "assets/team/Juan_Gomez-Lagandara.webp",
                team: "Volunteer"
            },
        ]
    }
    };

export default teamData;